<app-layout>
    <mat-toolbar class="page-header" role="heading">
      <h1>{{ 'BasicEmployeeReport' | translate: {Default: "Basic Employee Report"} }}</h1>
    </mat-toolbar>
  
    <div class="content">
        <app-basic-employee-details-data-grid></app-basic-employee-details-data-grid>
    </div>
</app-layout>